import {AbstractService} from 'services/AbstractService';

const EXPORTER_LIST_URL = '/api/export/statistics';


class GsExporterService extends AbstractService {

  list ({perPage, page}) {
    return this.client.get('/api/export/statistics', {per_page: perPage, page});
  }

  get (exporterId) {
    return this.client.get(
      `${EXPORTER_LIST_URL}/${exporterId}`
    );
  }

  create ({storage_url, statistics_url, metrics, from_date}) {
    return this.client.post(
      EXPORTER_LIST_URL,
      {
        storage_url,
        statistics_url,
        metrics,
        from_date
      }
    );
  }

  update (exporterId, {storage_url, statistics_url, metrics, from_date}) {
    return this.client.put(
      `${EXPORTER_LIST_URL}/${exporterId}`,
      {
        storage_url,
        statistics_url,
        metrics,
        from_date
      }
    );
  }

  delete (exporterId) {
    return this.client.delete(
      `${EXPORTER_LIST_URL}/${exporterId}`
    );
  }
}

export default GsExporterService;
